<template>
    <div class="loading-overlay" v-if="loading.getTrafiData || loading.getQuestions || loading.createListing">
        <div class="loading-icon">
            <i class="fa-duotone fa-spinner fa-spin"></i>
        </div>
    </div>
</template>
<script setup>
    import { storeToRefs } from 'pinia'
    import { useSellerStore } from '@stores/SellerStore'
    const sellerStore = useSellerStore()

    const { loading } = storeToRefs(sellerStore)
</script>